import moment from "moment";
import { useHistory } from "react-router-dom";
const { createSlice } = require("@reduxjs/toolkit");

export const initialState = {
  jobs: [],
};

const JobsSlice = createSlice({
  name: "Jobsdata",
  initialState,
  reducers: {
    setJobsData: (state, { payload }) => {
      state.jobs = payload;
    },
  },
});

export const { setJobsData } = JobsSlice.actions;

export default JobsSlice.reducer;
